export function buildCollabUrl(artifactId: string, baseUrl?: string): string {
  const origin =
    baseUrl ??
    (typeof import.meta.env !== 'undefined'
      ? (import.meta.env.VITE_COLLAB_ORIGIN as string | undefined)
      : undefined) ??
    window.location.origin;
  const url = new URL(`/api/artifacts/${encodeURIComponent(artifactId)}/collaboration`, origin);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
}
